import script from "./Base64FileField.vue?vue&type=script&setup=true&lang=js"
export * from "./Base64FileField.vue?vue&type=script&setup=true&lang=js"

import "./Base64FileField.vue?vue&type=style&index=0&id=660cf202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660cf202"]])

export default __exports__